module.exports = __webpack_public_path__ + "assets/img/dt.3fecf739.gif";